import { render, staticRenderFns } from "./format-banner-section.vue?vue&type=template&id=e0d5bbe8&"
import script from "./format-banner-section.vue?vue&type=script&lang=js&"
export * from "./format-banner-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports